// extracted by mini-css-extract-plugin
module.exports = {"header":"User_header__y8Z5K","grid":"User_grid__25GH3","icon":"User_icon__1DoXs","disabled":"User_disabled__19-q0"};